import { create } from 'zustand'
import {
  MinorAccessRequestData,
  UseMinorAccessRequestStore,
} from '../auth-types'

export const useMinorAccessRequestStore = create<UseMinorAccessRequestStore>(
  set => ({
    minorAccessRequestData: {} as MinorAccessRequestData,
    setMinorAccessRequestData: newData => {
      set(prevState => {
        const updatedState = {
          ...prevState,
          minorAccessRequestData: {
            ...prevState.minorAccessRequestData,
            ...newData,
          },
        }
        return updatedState
      })
    },
    resetMinorAccessRequestData: () =>
      set({ minorAccessRequestData: {} as MinorAccessRequestData }),
  }),
)
